import { useEffect } from 'react';

import { isBrowser } from '../../utils/is-browser';

import { DebugTriggers } from './debug-triggers';

export const useDebugNudgeTriggers = (): void => {
	useEffect(() => {
		if (!isBrowser()) {
			return;
		}

		if (!window?.AIX_DEBUG_NUDGE_TRIGGERS) {
			window.AIX_DEBUG_NUDGE_TRIGGERS = new DebugTriggers();
		}

		return () => {
			if (window.AIX_DEBUG_NUDGE_TRIGGERS) {
				delete window.AIX_DEBUG_NUDGE_TRIGGERS;
			}
		};
	}, []);
};
